import type { FilterField, FilterOption } from '@/components/common/AdvancedFilter';
import type { GeoUnit } from '@/features/geo/types/geo.types';
import type { InstituteType } from '@/features/instituteTypes/types/instituteType.types';
import type { HierarchyFilterOption } from '@/features/leaveApplications/types/leaveApplication.types';
import {
  DISTRICT_FIRST_FIELD_STATE,
  getDateFromToFilterFields,
  getInstituteTypeFilterField,
} from '@/utils/filterFields';
import {
  getSelectFieldsWhenOptionsExist,
  toFilterOptions,
  type OptionWithCount,
} from '@/utils/filters';
import {
  DATE_FROM_FILTER_KEY,
  DATE_TO_FILTER_KEY,
  SUBMISSION_STATUS,
  SUBMISSION_STATUS_LABELS,
  SUBMISSION_TYPE,
  SUBMISSION_TYPE_LABELS,
} from '../constants/instituteSubmission.constants';

const STATUS_OPTIONS: FilterOption[] = SUBMISSION_STATUS.map((status) => ({
  label: SUBMISSION_STATUS_LABELS[status],
  value: status,
}));

const SUBMISSION_TYPE_OPTIONS: FilterOption[] = SUBMISSION_TYPE.map((submissionType) => ({
  label: SUBMISSION_TYPE_LABELS[submissionType],
  value: submissionType,
}));

interface GetInstituteSubmissionFilterFieldsArgs {
  hasDistrict: boolean;
  instituteTypes: InstituteType[] | undefined;
  districts: GeoUnit[] | undefined;
  thanas: GeoUnit[] | undefined;
  amOptions: OptionWithCount<HierarchyFilterOption>[] | undefined;
  zmOptions: OptionWithCount<HierarchyFilterOption>[] | undefined;
}

export function getInstituteSubmissionFilterFields({
  hasDistrict,
  instituteTypes,
  districts,
  thanas,
  amOptions,
  zmOptions,
}: GetInstituteSubmissionFilterFieldsArgs): FilterField[] {
  return [
    ...getDateFromToFilterFields({ fromKey: DATE_FROM_FILTER_KEY, toKey: DATE_TO_FILTER_KEY }),
    { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS },
    {
      key: 'submissionType',
      label: 'Submission Type',
      type: 'select',
      options: SUBMISSION_TYPE_OPTIONS,
    },
    getInstituteTypeFilterField(instituteTypes),
    {
      key: 'districtId',
      label: 'District',
      type: 'select',
      options: toFilterOptions(districts),
      searchable: true,
    },
    {
      key: 'thanaId',
      label: 'Thana',
      type: 'select',
      options: toFilterOptions(thanas),
      searchable: true,
      ...(hasDistrict ? {} : DISTRICT_FIRST_FIELD_STATE),
    },
    ...getSelectFieldsWhenOptionsExist('amUserId', 'AM Name', amOptions),
    ...getSelectFieldsWhenOptionsExist('zmUserId', 'ZM Name', zmOptions),
  ];
}
